import { FASTElement as p, attr as n } from "@microsoft/fast-element";
import { popUpWidgetStyles as h } from "./pop-up-widget.styles.js";
import { popUpWidgetTemplate as f } from "./pop-up-widget.template.js";
var g = Object.defineProperty, r = (a, t, i, d) => {
  for (var s = void 0, o = a.length - 1, c; o >= 0; o--)
    (c = a[o]) && (s = c(t, i, s) || s);
  return s && g(t, i, s), s;
}, e;
const l = (e = class extends p {
  constructor() {
    super(...arguments), this.widgetTitle = "", this.open = !1, this.fullSize = !1;
  }
  invalidateMaxBodyHeight() {
    if (this.$fastController.isConnected) {
      const t = this.clientHeight, i = this._widgetHeader.clientHeight;
      this._widgetBody.style.maxHeight = t - i + "px";
    }
  }
  handleFullSizeButtonClick() {
    this.$emit("resize", null, { cancelable: !1 });
  }
  handleCloseButtonClick() {
    this.$emit("close", null, { cancelable: !1 });
  }
  connectedCallback() {
    super.connectedCallback(), e._resizeObserver.observe(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), e._resizeObserver.unobserve(this);
  }
  static onResize(t) {
    for (const i of t)
      i.target.invalidateMaxBodyHeight();
  }
}, e._resizeObserver = new ResizeObserver(
  e.onResize
), e.definition = {
  name: "pop-up-widget",
  template: f,
  styles: () => h
}, e);
r([
  n
], l.prototype, "widgetTitle");
r([
  n({ mode: "boolean" })
], l.prototype, "open");
r([
  n({ mode: "boolean" })
], l.prototype, "fullSize");
let v = l;
export {
  v as PopUpWidget
};
